module.exports = __webpack_public_path__ + "media/wallaby_m.7fc0bbb0.mp3";